/**
 * «Человек сейчас смотрит в это окно?»
 *
 * Нужно ровно для одного: не отмечать прочитанным то, чего человек не видел.
 * Открытая в фоновой вкладке комната — это НЕ прочитанная комната, и
 * мессенджер, который обнуляет счётчики просто потому, что страница загружена,
 * ведёт себя неправильно.
 *
 * Проверяем два разных условия, потому что они ловят разные случаи:
 *  - document.visibilityState — вкладка свёрнута/переключена;
 *  - document.hasFocus() — вкладка видна, но фокус в другом окне (человек
 *    смотрит в другое приложение поверх браузера).
 */
import { useEffect, useState } from "react";

function currentlyActive(): boolean {
  return document.visibilityState === "visible" && document.hasFocus();
}

export function useWindowActive(): boolean {
  const [active, setActive] = useState<boolean>(() => currentlyActive());

  useEffect(() => {
    const update = () => setActive(currentlyActive());
    // Синхронизируемся сразу: между первым рендером и подпиской фокус мог уйти.
    update();
    window.addEventListener("focus", update);
    window.addEventListener("blur", update);
    document.addEventListener("visibilitychange", update);
    return () => {
      window.removeEventListener("focus", update);
      window.removeEventListener("blur", update);
      document.removeEventListener("visibilitychange", update);
    };
  }, []);

  return active;
}
